// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChatButton_wrapper__oOgFx"};